import { Link } from 'react-router-dom';
import { getPublicAuthorName } from '../utils/profile';
import { isUuid } from '../utils/author';

function AuthorLink({ userId, name }) {
    const label = getPublicAuthorName(name);
    if (!isUuid(userId)) return <strong>{label}</strong>;

    return (
        <Link className="author-link" to={`/author?id=${userId}`} aria-label={`View ${label}'s author page`}>
            <strong>{label}</strong>
        </Link>
    );
}

export default AuthorLink;
